import PropTypes from 'prop-types';
import { Box, Select } from '@mui/material';

import { menuStyles, MENU_SHADOW } from 'components/simple/MenuPanel';
import { ArrowFilledDownIcon } from 'assets/icons';

const styles = {
  baseSelect: ({ palette }) => ({
    height: 40,
    borderRadius: 6,
    flex: '1 0',
    color: palette.text.secondary,
    fontSize: '16px !important',
    '.MuiSelect-select': {
      paddingBlock: 1,
      paddingLeft: 2,
    },
  }),
  baseSelectColored: ({ palette }, selectColor) => ({
    backgroundColor: palette?.[selectColor]?.main || palette.colors.liteLilac,
    '.MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${palette.colors[selectColor || 'darkPale']} !important`,
    },
  }),
  baseSelectMenu: ({ palette }) => ({
    borderRadius: 2.5,
    boxShadow: MENU_SHADOW,
    marginTop: 0.5,
    '.MuiMenu-list': {
      padding: 'unset !important',
      border: `1px solid ${palette.colors.darkPale}`,
      '.MuiMenuItem-root': {
        ...menuStyles.selectOption({ palette }),
        paddingBlock: 1.5,
        paddingInline: 2,
        borderBottom: `1px solid ${palette.colors.darkPale}`,
        fontSize: 16,
      },
    },
  }),
  baseSelectIcon: ({ palette }) => ({
    color: palette.text.secondary,
    width: 12,
    height: 12,
    position: 'absolute',
    right: 16,
    top: 'calc(50% - 6px)',
    cursor: 'pointer',
  }),
};

export const DataGridSelect = ({ getSelectColor = () => {}, ...selectProps }) => {
  return (
    <Select
      {...selectProps}
      variant="outlined"
      IconComponent={() => <Box component={ArrowFilledDownIcon} sx={styles.baseSelectIcon} />}
      MenuProps={{
        ...selectProps.MenuProps,
        slotProps: {
          paper: { sx: styles.baseSelectMenu },
        },
      }}
      sx={[styles.baseSelect, (theme) => styles.baseSelectColored(theme, getSelectColor?.(selectProps.value))]}
    />
  );
};

DataGridSelect.propTypes = {
  getSelectColor: PropTypes.func,
  value: PropTypes.string,
  MenuProps: PropTypes.shape({}),
};
